// 香港站 (matchmaker.findu2.love) talks to the US API (REACT_APP_API_URL), so a
// fresh upload is saved in the US and only reaches the HK disk with the
// once-a-minute uploads sync. Until then HK answers /uploads/… with 404 and the
// picture shows broken. When a same-site /uploads image fails, load it once
// more from the API's site, which has the file from the start.
export function installUploadsFallback() {
  let apiOrigin = null;
  try { apiOrigin = new URL(process.env.REACT_APP_API_URL).origin; } catch (e) { return; }
  if (!apiOrigin || apiOrigin === window.location.origin) return;
  // `error` doesn't bubble from <img>; listen in the capture phase on window.
  window.addEventListener('error', (e) => {
    const el = e.target;
    if (!el || el.tagName !== 'IMG' || el.dataset.uploadsRetry) return;
    let u;
    try { u = new URL(el.currentSrc || el.src, window.location.href); } catch (err) { return; }
    if (u.origin !== window.location.origin || !u.pathname.startsWith('/uploads/')) return;
    el.dataset.uploadsRetry = '1';
    // Some components hide an <img> in their own onError; show it again once the retry loads.
    el.addEventListener('load', () => { el.style.display = ''; }, { once: true });
    el.src = apiOrigin + u.pathname + u.search;
  }, true);
}
